import OffersSummary from "./OffersSummary";

export default OffersSummary;
